import DOMPurify from 'dompurify';
import { useMemo } from 'react';

import ErrorBoundary from '../ErrorBoundary';

interface HtmlContentProps {
  content: string | Node;
  config?: DOMPurify.Config;
}

export const HtmlContent = ({ content, config = {} }: HtmlContentProps) => {
  const props = useMemo(
    () => ({
      __html: DOMPurify.sanitize(content, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['target'],
        FORBID_TAGS: ['form'],
        ...config,
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM: false,
      }),
    }),
    [content, config],
  );

  return (
    <ErrorBoundary>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={props} />
    </ErrorBoundary>
  );
};

export default HtmlContent;
